module.exports = {

    data() {
        return {
            autocomplete: null,
            addressParts: {
                street_number: {
                    key: 'short_name',
                    to: 'number',
                    join: ''
                },
                route: {
                    key: 'long_name',
                    to: 'street',
                    join: ' '
                },
                locality: {
                    key: 'long_name',
                    to: 'city',
                    join: ''
                },
                administrative_area_level_1: {
                    key: 'short_name',
                    to: 'state',
                    join: ''
                },
                administrative_area_level_2: {
                    key: 'short_name',
                    to: 'county',
                    join: ''
                },
                postal_code: {
                    key: 'short_name',
                    to: 'zip',
                    join: ''
                },
            }
        }
    },

    mounted() {
        App.bus.$on('google-api-ready', this.createAutocompleteAddress)
    },

    methods: {

        createAutocompleteAddress(id = 'autocomplete-address') {
            var input = document.getElementById(id);
            if(!input) return;
            this.autocomplete = new google.maps.places.Autocomplete(input);

            this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
            this.autocomplete.addListener('place_changed', () => {

                var place = this.autocomplete.getPlace();

                this.setAddressFromPlace(place)

                if (!place.geometry) {
                    Toast.error("No details available for input: '" + place.name + "'");
                    return;
                }

            });
        },

        setAddressFromPlace(place){
            // Call this method from parent.
        },
    }
}